import './index.css'
import { useEffect } from 'react';
import Header from './header'
import GpaCalculator from './Gpa-calculator';
import CgpaCalculator from './Cgpa-calculator';

function App() {

  useEffect(() => {
    alert(
      "Welcome to v1.0 of CGPA Calculator!\nPlease click on the number at the bottom of the website and give feedback."
    );
  }, []);

  return (
    <div className="App">
      <Header />

      <GpaCalculator />

      <CgpaCalculator />

      <footer>
        <p>The website was created by Laitech team. for more enqueries, contact me on whatsapp: 
          <a
            href="https://wa.me/2347062639160"
            target="_blank"
            rel="noopener noreferrer"
          >
            07062639160
          </a> 
    </p>
      </footer>
    </div>
  );  
}

export default App;
